import { roots } from '../main';

export const closeChat = (domElementId) => {
  const root = roots.get(domElementId);

  if (root) {
    root.unmount();
    roots.delete(domElementId);
  }
};
